// re creating this enum here because gatsby gives error if enum imported from @zeus/shared
export enum ButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
}

// export enum ImageCornerVariant {
//   SHARP_CORNERS = 'sharpCorners',
//   SOFT_CORNERS = 'softCorners',
// }

export enum SECTION_HEIGHT {
  DEFAULT = 'DEFAULT',
  HALF_SCREEN_HEIGHT = 'HALF_SCREEN_HEIGHT',
  FULL_SCREEN_HEIGHT = 'FULL_SCREEN_HEIGHT',
  CUSTOM = 'CUSTOM',
}

export enum ContentPosition {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export enum MediaType {
  IMAGE = 'image',
  VIDEO = 'video',
}

export enum HEADER_STATE {
  STICKY = 'sticky',
  SCROLL_UP = 'scrollUp',
  DEFAULT = 'default',
}

export enum FormFieldEnum {
  NAME = 'name',
  EMAIL = 'email',
  PHONE = 'phone',
  ADDRESS = 'address',
  DROPDOWN = 'dropdown',
  DATE = 'date',
  TIME = 'time',
  SHORT_ANSWER = 'short_answer',
  LONG_ANSWER = 'long_answer',
  FILE = 'file',
  MULTIPLE = 'multiple_choice',
  NUMBER = 'number',
}

export enum SCREEN_SIZE {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
}

export enum FormTemplateEnum {
  PRIVATE_EVENTS = 'private_events',
  CONTACT_US = 'contact_us',
  FEEDBACK_FORM = 'feedback_form',
  CUSTOM_FORM = 'custom_form',
}

export enum ServiceType {
  OFF_PREMISE = 'Off-premise',
  ON_PREMISE = 'On-premise',
}

export enum EventType {
  CORPORATE = 'Corporate',
  BIRTHDAY = 'Birthday',
  WEDDING = 'Wedding',
  ENGAGEMENT = 'Engagement',
  BABY_SHOWER = 'Baby shower',
  BRIDAL_SHOWER = 'Bridal shower',
  GRADUATION_PARTY = 'Graduation party',
  RELIGIOUS = 'Religious',
  HOLIDAY = 'Holiday',
  OTHER = 'Other',
}

// re creating this enum here because gatsby gives error if enum imported from @zeus/shared
export enum COMPONENT_KEY {
  HEADER = 'HEADER',
  HERO = 'HERO',
  ABOUT_US = 'ABOUT_US',
  LOCATION = 'LOCATION',
  FOOTER = 'FOOTER',
  IMAGE_GALLERY = 'IMAGE_GALLERY',
  FEATURED_MENU = 'FEATURED_MENU',
  DEALS = 'DEALS',
  SPOTLIGHTS = 'SPOTLIGHTS',
  CUSTOM_SECTION = 'CUSTOM_SECTION',
  MENU = 'MENU',
  CALL_TO_ACTION = 'CALL_TO_ACTION',
  HOW_IT_WORKS = 'HOW_IT_WORKS',
  GIFT_CARDS = 'GIFT_CARDS',
  TIERS_POINTS = 'TIERS_POINTS',
  FORM = 'FORM',
  CATERING_FORM = 'CATERING_FORM',
  LOYALTY_FORM = 'LOYALTY_FORM',
  INFO_CARDS = 'INFO_CARDS',
  TESTIMONIALS = 'TESTIMONIALS',
  ACCESSIBILITY = 'ACCESSIBILITY',
  PACKAGES = 'PACKAGES',
}

// Order Source Enum
export enum CateringOrderSource {
  WEB_SITE = 'WEB-SITE',
  DASH = 'DASH',
}

// re creating this enum here because gatsby gives error if enum imported from @zeus/shared
export enum VARIANT_KEY {
  VARIANT1 = 'VARIANT1',
  VARIANT2 = 'VARIANT2',
  VARIANT3 = 'VARIANT3',
  VARIANT4 = 'VARIANT4',
}

export enum RadiusEnum {
  SHARP = 'sharp',
  SOFT = 'soft',
  CUSTOM = 'custom',
}

export enum MapTheme {
  LIGHT = 'light',
  DARK = 'dark',
}
export interface IComponentMap {
  [key: string]: {
    [key in keyof typeof VARIANT_KEY]?: {
      component: JSX.Element;
      initialProps: any;
      skeleton: any;
    };
  };
}

export enum IMENU_NAV {
  SIDEBAR = 'sidebar',
  TOPBAR = 'topbar',
}

export interface RadiusType {
  radius: RadiusEnum;
  value: number;
}
